import { ShipmentInfo } from 'api';
import React, { ChangeEvent } from 'react';
import { Box, FilePicker, Link, SectionContainer } from 'ui';

type BookingConfirmationDocProps = {
  shipmentData?: ShipmentInfo;
  handleFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const BookingConfirmationDoc = ({ shipmentData, handleFileChange }: BookingConfirmationDocProps) => {
  const bookingConfirmation = shipmentData?.booking_confirmation;

  return (
    <SectionContainer columns={1} title="Booking Confirmation Document">
      {bookingConfirmation?.file_url ? (
        <Box my={1}>
          Currently:{' '}
          <Link href={bookingConfirmation.file_url} fontWeight="bold">
            {bookingConfirmation.alias || bookingConfirmation.file_name}
          </Link>
        </Box>
      ) : null}
      <Box mt={1} mb={2}>
        <FilePicker accept="*" onChange={handleFileChange} label="Upload Document" showSelectedFileName />
      </Box>
    </SectionContainer>
  );
};
